<template>
  <div>

    <br>

    <v-row justify="center">
      <v-dialog v-model="dialogIndividual" width="430px">
        <v-card>
          <v-card-text style="text-align: justify;">
            <div>
              <v-btn icon @click="dialogIndividual = false" style="float: right;">
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <br>
              <br>
              <div style="background: #002C77; border-radius: 9px; text-align: center;">
                <div style="padding: 2%;">
                  <label style="font-family: Poppins; font-style: normal; font-weight: 700; font-size: 13px; line-height: 18px; letter-spacing: 0.02em;
                      color: white; flex: none; order: 1; flex-grow: 0;">Estas son las coberturas y protecciones
                    del </label>
                  <label style="font-family: Poppins; font-style: normal; font-weight: 700; font-size: 13px; line-height: 18px; letter-spacing: 0.02em;
                      color: white; flex: none; order: 1; flex-grow: 0;"><label
                      style="font-family: Poppins; font-style: normal; font-weight: 700; 
                      font-size: 13px; line-height: 18px; letter-spacing: 0.02em; color: white; flex: none; order: 1; flex-grow: 0; text-transform: uppercase;">
                    </label> <br> Seguro Oncológico Clínica IRAM.
                  </label>
                </div>

              </div>


              <br>
              <div style="padding-left: 5%; ">
                <label class="encabezado"> ⬤ <b> Cobertura completa en tratamiento oncológico individual </b> </label>
              </div>

              <br>

              <div style="padding-left: 5%; padding-right: 5%;  margin-bottom: 10px">
                <label class="texto">La cobertura tiene como finalidad complementar el régimen previsional de salud del
                  asegurado, sea Fonasa (B, C, D) o Isapre, proporcionando acceso a tratamientos, hospitalización para
                  patologías oncológicas y seguimiento oncológico, con cobertura vitalicia mientras el asegurado
                  mantenga su pago y contrato vigente.</label>
              </div>
              <div style="padding-left: 5%; padding-right: 5%;  margin-bottom: 20px">
                <label class="texto">La cobertura es de carácter asistencial y contempla una indemnización de UF 50 en
                  caso de diagnóstico de cáncer. El derecho a la indemnización no procederá si el diagnóstico de cáncer
                  es consecuencia de otro anterior cubierto por la póliza. Todos los tratamientos y prestaciones deben
                  ser indicados sólo por Clínica IRAM, realizados en su propia Clínica o en centros derivados por la
                  misma.</label>
              </div>
              <div style="padding-left: 5%; padding-right: 5%;  margin-bottom: 5px">
                <label class="texto">La cobertura oncológica se inicia una vez que el paciente presenta el resultado de
                  una biopsia (informe histopatológico), que confirma que tiene cáncer. La realización de esta biopsia
                  es de cargo del asegurado.</label>
              </div>

              <br>
              <div style="padding-left: 9%; ">
                <label class="encabezado"> ⬤ <b> Beneficios adicionales </b> </label>
              </div>


              <br>
              <div style="padding-left: 5%; padding-right: 5%;  margin-bottom: 20px">
                <label class="texto">La cobertura y beneficios adicionales es complementaria al sistema previsional de
                  cada persona (Fonasa o Isapre), es decir cubrirá los valores copago no cubiertos por éstas.</label>
              </div>

              <div style="padding-left: 5%; padding-right: 5%;  margin-bottom: 20px">
                <label class="texto"> <b>Para diagnóstico precoz del cáncer de mama: </b> <br>
                  • 1 mamografía anual sin costo desde los 35 años.<br>
                  • Este examen se realiza: en Santiago y en regiones en los Centros Médicos convenidos por IRAM.
                </label>
              </div>

              <div style="padding-left: 5%; padding-right: 5%;  margin-bottom: 20px">
                <label class="texto"> <b>Para diagnóstico precoz del cáncer de próstata:</b><br>
                  • 1 examen anual de antígeno prostático específico (PSA) sin costo desde los 45 años.<br>
                  • Este examen se realiza: en Santiago y en regiones en los Centros Médicos convenidos por IRAM.
                </label>
              </div>

              <br>

            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn style="box-sizing: border-box; padding: 12px 24px; gap: 10px; background: #4F74E3; border: 2px solid #4F74E3;
                    border-radius: 8px; margin-top: -6%; font-family: Poppins; font-style: normal; font-weight: 700; font-size: 14px; line-height: 17px;
                    letter-spacing: 0.02em; color: white; flex: none; order: 0; flex-grow: 0; margin:auto;"
              elevation="0" text @click="dialogIndividual = false">
              Aceptar
            </v-btn>
            <br>
            <br>
            <br>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-row>

    <v-form ref="form" v-model="valid">
      <div>
        <h3 class="text-center labelTituloo">{{ capitalizeName(userData.name) }},
          tenemos este plan para ti</h3>
        <br>

        <v-row style="
              background: #f7f7f7;
              border: rgba(226, 226, 226, 1) 1px solid;
              border-radius: 50px;
              overflow: hidden;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
              flex-wrap: nowrap;
              margin-left: 0.5%;
            ">
          <div style="justify-content: center; display: flex; width: 50%; margin-left: 3%;">
            <img :src="imageIndividual" alt="Image i" @click="selectPlan(1)" style="cursor: pointer;">
          </div>
          <div v-if="userData.old.id < 53" style="justify-content: center; display: flex; width: 50%;">
            <img :src="imageFamiliar" alt="Image f" @click="selectPlan(2), dialog = true" style="cursor: pointer;">
          </div>
        </v-row>

        <v-navigation-drawer v-model="dialog" right temporary fixed width="450" class="family-drawer" app stateless
          touchless disable-route-watcher disable-resize-watcher>


          <v-card flat tile class="drawer-card">

            <v-card-title>

              <v-row style="margin-left: 10%; margin-top: 2%;">

                <img :src="popUpImage" alt="Image pop">

                <v-col style="margin-left: 10%; display: flex; flex-direction: column; flex-wrap: wrap;align-content: stretch;
                          justify-content: space-evenly;  align-items: baseline; ">
                  <p style="color: #2D387C; font-weight: 600; align-items: left;">Plan familiar</p>
                  <p style="color: #353535; font-size: 13px; align-items: left; margin-top: -6%;">Agrega hasta 5
                    integrantes <br> de tu
                    grupo familiar.</p>
                </v-col>

                <span style="margin-right: 3%;" @click="dialog = false">X</span>

              </v-row>

              <hr class="hrline"><br>

            </v-card-title>

            <v-card-text style="text-align: justify;">

              <v-col>
                <p> <span style="font-weight: 700; color: #353535;">Ya estás incluido en el plan.</span> <br> Aquí
                  puedes agregar a tus cargas familiares. </p>

                <br>

                <div>

                  <div v-for="(benef, index) in benefData" :key="index" class="benef-card">
                    <br>
                    <div class="benef-header" style="display: flex; flex-direction: nowrap; align-items: top;">
                      <p class="benef-title" style="margin-right: 60%;">FAMILIAR {{ index + 1 }}</p>

                      <button class="benef-remove" @click.prevent="deletedBeneficiary(index)">
                        Eliminar
                        <span class="benef-x">×</span>
                      </button>
                      <br>
                    </div>



                    <div class="field-row-2">

                      <div>
                        <label class="field-label">Nombre</label>
                        <v-text-field v-model="benef.name" class="input-sm" dense outlined rounded hide-details
                          :rules="nameRules" placeholder="Nombre" />
                      </div>

                      <div>
                        <label class="field-label">Apellido</label>
                        <v-text-field v-model="benef.surname" class="input-sm" dense outlined rounded hide-details
                          :rules="surnameRules" placeholder="Apellido" />
                      </div>

                    </div>

                    <div class="field-row-2">
                      <div>
                        <label class="field-label">Parentesco</label>
                        <v-select v-model="benef.tipo" :items="personType" class="input-sm" dense outlined rounded
                          :rules="parentescoRules" hide-details placeholder="Seleccione"
                          @change="change(index, benef.tipo)" />
                      </div>

                      <div>
                        <label class="field-label">Edad</label>

                        <v-select v-if="benef.tipo != 'Hijo(a)'" v-model="benef.edad" :items="partnerList"
                          item-text="name" class="input-sm" dense outlined rounded hide-details placeholder="Edad"
                          :rules="oldRules" @change="mayorEdad()" />

                        <v-select v-else v-model="benef.edad" :items="hijoList" item-text="name" class="input-sm" dense
                          outlined rounded hide-details placeholder="Edad" @change="mayorEdad()" />
                      </div>
                    </div>
                  </div>

                  <br>
                  <div class="btn-center">
                    <v-btn class="btn-add" elevation="0" @click="addBeneficiary()">
                      <span class="plus">+</span> AGREGAR OTRO FAMILIAR
                    </v-btn>
                  </div>

                </div>

              </v-col>

            </v-card-text>

            <v-card-actions class="actions-vertical" style="flex-direction: column;">

              <v-btn style="color: white; margin: auto; height: 42px; padding: 15px 46px;
                 border-radius: 100px; background: #4F74E3;" elevation="0" @click="dialog = false">
                ¡Todo listo!
              </v-btn>

              <v-btn text style="margin-top: 20px; color:#4F74E3;" @click="dialog = false">
                X Prefiero plan individual
              </v-btn>

            </v-card-actions>


          </v-card>


        </v-navigation-drawer>

        <br><br>

        <v-row v-if="planDataAux.plan.cantBenf.includes('familiar')" style="display: flex; justify-content: center;">
          <p style="margin-right: 10%;">Número de cargas agregadas: {{ benefData.length }} </p>
          <p style="color: #2A3881; font-weight: 600; cursor: pointer;" @click="dialog = true">Editar familiares</p>
        </v-row>
      </div>

    </v-form>


    <div class="ContainerPlans" v-if="loadingPlans == false">

      <div>

        <div class="planFamiliarConveniente">Plan Seguro Oncológico </div>

      </div>

      <div class="plan-valid">

        <div class="planFamiliarConvenienteValid">Válido para Fonasa e Isapre</div>

      </div>

      <div>

        <p class="planFamiliarName" style="margin-top: 3%;">Precio mensual</p>

        <div style="display: flex; justify-content: center; height: 33px; margin-top: 2%;">
          <p class="planFamiliarPrecio">{{ formatPrice(planDataAux.plan.values[0].priceCLP) }} *</p>
          <div>
            <p></p>
            <p class="planFamiliarSubPrecio"> UF {{ (planDataAux.plan.values[0].price).toFixed(2) }}</p>
          </div>

        </div>


        <label class="planFamiliarSubDetalle">* Valor de la UF al día de hoy, {{ currentDate }}.</label>

        <div class="planShield" style="margin-top: 3%;">
          <img :src=iconShield alt="Protecciones" class="imgShield">
          <p class="planShieldDetalle">El Plan otorga <span style="color: #4F74E3;font-weight: 600;">atención y
              cobertura</span> completa de los gastos que implica el tratamiento, control y seguimiento del cáncer.</p>
        </div>

        <div class="planSubShield">
          <img :src=iconSand alt="Protecciones" class="imgSand">
          <p class="planSubShieldDetalle">Este seguro tiene un tiempo de espera de activación de 30 días contínuos.</p>
        </div>

        <p></p>


      </div>


      <hr class="hrLinePlan">

      <br>

      <div class="plan-skin" style="border-radius: 0px 0px 0px 0px !important;">

        <h3 class="titleLabel2" style="margin: auto;margin-bottom: 3%;">Esto incluye tu plan</h3>

        <p class="planIndividualBeneficios">Cubre tratamiento para todos los tipos de cáncer, incluso cáncer in situ y
          el tratamiento del cáncer a la piel.
        </p>
        <p></p>
        <p class="planIndividualBeneficios">La atención oncológica es solo en la ciudad de Santiago de Chile. Traslados
          y estadías no estarán cubiertos por el seguro.
        </p>
        <p></p>
        <p class="planIndividualBeneficios">Todo el tratamiento integral del paciente lo realiza Clínica IRAM, derivando
          a los profesionales y/o centros hospitalarios en convenio en la ciudad de Santiago.
        </p>
        <p></p>
        <p class="planIndividualBeneficios">Cubre la realización de exámenes y procedimientos necesarios para
          identificar el tipo y estado de extensión del cáncer.
        </p>
        <p></p>
        <p class="planIndividualBeneficios">Ejecución de tratamiento comprobado y multidisciplinario de la enfermedad
          (Cirugía, Quimioterapia y Radioterapia).
        </p>
        <p></p>
        <p class="planIndividualBeneficios">Hospitalización como un todo. Incluye los días cama, derechos de pabellón,
          UTI intermedio, procedimientos diagnósticos intrahospitalarios.
        </p>
        <p></p>
        <p class="planIndividualBeneficios">Incluye todos los honorarios médicos: quirúrgicos, de radioterapeutas, de
          quimioterapeutas y honorarios del equipo paramédico quirúrgico.
        </p>
        <p></p>
        <p class="planIndividualBeneficios">Cobertura vitalicia mientras se mantenga el pago y la póliza vigente.
        </p>
        <p></p>
        <p class="planIndividualBeneficios">Ante diagnóstico de cáncer positivo, recibirás una indemnización de UF 50
          para libre disposición.
        </p>
        <p></p>
        <div class="plan-info">
          <button style="display: flex; margin: auto; align-items: center; text-align: center;">
            <b>
              <u class="planIndividualVerDetalle" elevation="0" @click="InfoIndividual()">
                VER MÁS DETALLES
              </u>
            </b>
          </button>
        </div>
        <p></p>
        <p class="planSubTopes"
          style="text-align: center !important;font-size: 13px !important;width: 73%;margin: auto;">Topes posteriores a
          tu cobertura de Fonasa o Isapre:
        </p>
        <p></p>
        <p class="planIndividualBeneficios">Drogas antineoplásicas: tope UF 100 por cada tratamiento de quimioterapia.
        </p>
        <p></p>
        <p class="planIndividualBeneficios">Farmacia intrahospitalaria: medicamentos, insumos, materiales clínicos y
          banco de sangre: UF 4 tope por hospitalización.
        </p>

        <p style="margin-top: 13%;"></p>
        <br>

      </div>

      <hr class="hrLinePlan" style="margin-top: -15%;margin-bottom: 6%;">

      <div class="plan-skin">
        <div class="text-center">
          <p class="planSubTopes" style="text-align: center !important;font-size: 14px !important;">Estamos para aclarar
            tus dudas</p>
        </div>

        <div>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel style="margin-bottom: 2%; margin-top: 2%;">
              <v-expansion-panel-header style="line-height: 18px;">
                ¿Este seguro tiene beneficios adicionales?
              </v-expansion-panel-header>
              <v-expansion-panel-content class="text-expan">
                Sí, este seguro cuenta con los siguientes beneficios:
                <ul class="listBenef">
                  <li>1 mamografía anual sin costo desde los 35 años para mujeres.</li>
                  <li>1 examen anual de antígeno prostático específico (PSA) sin costo desde los 45 años para hombres.
                  </li>
                </ul>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel style="margin-bottom: 2%">
              <v-expansion-panel-header style="line-height: 18px;">
                ¿Cómo uso mi seguro?
              </v-expansion-panel-header>
              <v-expansion-panel-content class="text-expan">
                Si te diagnostican cáncer, notifícalo a través de nuestro sitio web o por correo a
                <a href="mailto:siniestros@sbins.cl">siniestros@sbins.cl</a> o al <strong>800 200 802</strong>
                lo antes posible (máximo 30 días, salvo fuerza mayor).<br /><br />
                <strong>Documento requerido para la denuncia del siniestro:</strong>
                Informe de biopsia con diagnóstico de cáncer confirmado.
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel style="margin-bottom: 2%">
              <v-expansion-panel-header style="line-height: 18px;">
                ¿Qué es la Clínica IRAM?
              </v-expansion-panel-header>
              <v-expansion-panel-content class="text-expan">
                Clínica IRAM cuenta con más de 45 años de trayectoria dedicados al tratamiento del cáncer.
                Posee tecnología de primer nivel y un equipo médico multidisciplinario altamente calificado.
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel style="margin-bottom: 2%">
              <v-expansion-panel-header style="line-height: 18px;">
                ¿Puedo contratarlo si tengo Fonasa?
              </v-expansion-panel-header>
              <v-expansion-panel-content class="text-expan">
                Este seguro puede ser contratado con los tramos B, C y D de Fonasa. No incluye Fonasa “A” ni PRAIS.
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel style="margin-bottom: 2%">
              <v-expansion-panel-header style="line-height: 18px;">
                Soy parte de las fuerzas de orden y seguridad de Chile ¿Puedo contratarlo?
              </v-expansion-panel-header>
              <v-expansion-panel-content class="text-expan">
                Sí, este seguro cubre FFAA, Carabineros, PDI.
              </v-expansion-panel-content>
            </v-expansion-panel>

          </v-expansion-panels>
        </div>

        <br>

        <v-btn class="button-desing"
          style="background-color: #FFFFFF; display: flex; margin: auto; align-items: center;"
          @click="next(planData[0], 0)">
          <label style="color: #FFFFFF;">Continuar</label>
        </v-btn>

        <br>
        <br>


      </div>

    </div>
  </div>
</template>

<script>
import ShieldService from "@/services/shield.service.js";
import LibreEleccion from "../assets/images/libreeleccion.png";
import iconShield from "../assets/images/shield-check.svg";
import iconSand from "../assets/images/time-sand.svg";
import CryptoJS from 'crypto-js';
import Vue from "vue";
import { VueReCaptcha } from 'vue-recaptcha-v3'
const { VUE_APP_RECAPTCHA3_SITE_KEY } = process.env;
Vue.use(VueReCaptcha, { siteKey: VUE_APP_RECAPTCHA3_SITE_KEY })

import swal from 'sweetalert';


import agelist from "@/services/age-list.service.js";
import hijoList from "@/services/hijo-list.service.js";
import partnerList from "@/services/partner-age-list.service.js";

import planIndividualColorMobile from "@/assets/images/planIndividualColorMobile.svg";
import planFamiliarColorMobile from "@/assets/images/planFamiliarColorMobile.svg";
import planIndividualMobile from "@/assets/images/planIndividualMobile.svg";
import planFamiliarMobile from "@/assets/images/planFamiliarMobile.svg";
import popUpImage from "@/assets/images/popUpImage.svg";

export default {
  name: "Plan",
  props: ["planData", "planDataAux", "index", "userData", "benefData", "loadingPlans", "servicesData", "plansOutDesc"],
  data() {
    return {
      secretKey: process.env.VUE_APP_CRYPT,
      newElegirPlanIndividual: 'elegirPlan',
      newElegirPlanFamiliar: 'elegirPlan',
      stepperColor: '#4F74E3',
      verMasIndividual: false,
      verMasFamiliar: false,
      formatter: new Intl.NumberFormat("es-CL", {
        style: "currency",
        currency: "CLP",
      }),
      valid: false,
      popUpImage,
      imageIndividual: planIndividualColorMobile,
      imageFamiliar: planFamiliarMobile,
      iconSand,
      currentDate: "",
      iconShield,
      LibreEleccion,
      formatterUF: new Intl.NumberFormat("es-CL"),
      e1: 3,
      info: [['Isapre Individual', 'Isapre Familiar', 'Fonasa Individual', 'Fonasa Familiar'], ['100%', '100%', '100%', '100%'], ['50', '50', '50', '50'], ['30.000', '30.000', '30.000', '30.000'], ['5.000', '5.000', '5.000', '5.000'], ['50', '50', '50', '50'], ['10', '10', '10', '10'], ['0', '30.000', '0', '30.000'], ['0', '50', '0', '50']],
      indexInfo: '0',
      dialogIndividual: false,
      dialogFamiliar: false,
      dialog: false,
      dialogInternal: false,
      document: null,
      agelist: [],
      hijoList: [],
      partnerList: [],
      personType: [
        "Hijo(a)",
        "Pareja",
        "Cónyuge",
      ],
      activeCampaingUse: process.env.VUE_APP_ACTIVE_CAMPAIGN ? process.env.VUE_APP_ACTIVE_CAMPAIGN : 'FALSE',
      couponRules: [
        (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 caracteres"
      ],
      // benefData: [
      //   {
      //     tab: '',
      //     validRut: false,
      //     tipo: null,
      //     edad: null,
      //     name: '',
      //     surname: '',
      //     rut: '',
      //     days: ['Selecciona el mes'],
      //     months: null,
      //     years: null,
      //     date: null,
      //     newRut: '',
      //     panel: 0,
      //     year: null,
      //     month: null,
      //     day: null,
      //   }
      // ],
      parentescoRules: [
        (v) => !!v || "El parentesco es requerido",
      ],
      nameRules: [
        // (v) => !!v || "El nombre es requerido",
        (v) => !!v.trim() || "El nombre es requerido",
        // (v) => !/^[0-9]*$/.test(v) || "Ingrese solo letras",
        (v) => /^[a-zA-ZáéíóúüÜñÑ\s]+$/.test(v) || "Ingrese solo letras",
        (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 carácteres"
      ],
      surnameRules: [
        // (v) => !!v || "El apellido es requerido",
        (v) => !!v.trim() || "El apellido es requerido",
        (v) => /^[a-zA-ZáéíóúüÜñÑ\s-]+$/.test(v) || "Ingrese solo letras",
        (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 carácteres"
      ],
      oldRules: [
        (v) => !!v || "La edad es requerida",
      ],
    }
  },
  async mounted() {

    if ("imageIndividual" in sessionStorage) {
      this.imageIndividual = sessionStorage.getItem('imageIndividual');
      this.imageFamiliar = sessionStorage.getItem('imageFamiliar');
    }

    let index = sessionStorage.getItem('index');
    if (index == 2) {
      this.planDataAux.plan = this.planData[1];
    }

    if (this.userData.old.id > 52) {
      this.planDataAux.plan = this.planData[0];
    }

    this.getAgeList();
    this.getHijoList();
    this.getPartnerList();
    this.mayorEdad();

    document.body.scrollTop = document.documentElement.scrollTop = 0;
    const today = new Date();
    this.currentDate = today.toLocaleDateString("es-CL");
  },
  methods: {
    change(index, tipo) {
      const tiposRestringidos = ['Pareja', 'Cónyuge'];

      if (tiposRestringidos.includes(tipo)) {
        const existe = this.benefData.some(
          (b, i) => tiposRestringidos.includes(b.tipo) && i !== index
        );

        if (existe) {
          swal({
            title: "¡Atención!",
            text: "¡No puedes agregar más de un conviviente o pareja!",
            icon: "info",
            button: "De acuerdo",
          });
          this.$nextTick(() => {
            this.benefData[index].tipo = '';
          });
          return;
        }
      }

      this.benefData[index].tipo = tipo;
    },
    ufFormat(price) {
      return this.formatterUF.format(price);
    },
    VerMasIndividual() {
      if (this.verMasIndividual == false) {
        this.verMasIndividual = true
        this.newElegirPlanIndividual = 'elegirPlan2'
      } else {
        this.verMasIndividual = false
        this.newElegirPlanIndividual = 'elegirPlan'
      }
    },
    VerMasFamiliar() {
      if (this.verMasFamiliar == false) {
        this.verMasFamiliar = true
        this.newElegirPlanFamiliar = 'elegirPlan2'
      } else {
        this.verMasFamiliar = false
        this.newElegirPlanFamiliar = 'elegirPlan'
      }
    },
    formatPrice(number) {
      return this.formatter.format(number);
    },
    InfoFamiliar() {
      if (this.planData[1].name == 'Plan Familiar ISAPRE') {
        this.indexInfo = 1
        this.document = '/documents/ISAPRE_v2.pdf'
      }
      else if (this.planData[1].name == 'Plan Familiar FONASA') {
        this.indexInfo = 3
        this.document = '/documents/FONASA_v2.pdf'
      }
      this.dialogFamiliar = true
    },
    InfoIndividual() {
      if (this.planData[0].name == 'Plan Individual ISAPRE') {
        this.indexInfo = 0
        this.document = '/documents/ISAPRE_v2.pdf'
      }
      else if (this.planData[0].name == 'Plan Individual FONASA') {
        this.indexInfo = 2
        this.document = '/documents/FONASA_v2.pdf'
      }
      this.dialogIndividual = true
    },
    async selectPlan(index) {
      if (index == 1) {
        sessionStorage.setItem('index', index);
        this.imageIndividual = planIndividualColorMobile;
        this.imageFamiliar = planFamiliarMobile;
        sessionStorage.setItem('imageIndividual', planIndividualColorMobile);
        sessionStorage.setItem('imageFamiliar', planFamiliarMobile);
        this.planDataAux.plan = this.planData[0];
      } else if (index == 2) {
        sessionStorage.setItem('index', index);
        this.imageIndividual = planIndividualMobile;
        this.imageFamiliar = planFamiliarColorMobile;
        sessionStorage.setItem('imageIndividual', planIndividualMobile);
        sessionStorage.setItem('imageFamiliar', planFamiliarColorMobile);
        this.planDataAux.plan = this.planData[1];
      }
    },
    addBeneficiary() {
      if (this.benefData.length <= 3) {
        let beneficiarioAux = {
          tab: '',
          validRut: false,
          tipo: null,
          edad: null,
          name: '',
          surname: '',
          rut: '',
          days: ['Selecciona el mes'],
          months: null,
          years: null,
          date: null,
          newRut: '',
          panel: 0,
          year: null,
          month: null,
          day: null,
        }
        this.benefData.push(beneficiarioAux);
      } else {
        swal({
          title: "¡Atención!",
          text: "¡No puedes agregar mas familiares!",
          icon: "info",
          button: "De acuerdo",
        });
      }
    },
    async deletedBeneficiary(index) {
      if (this.benefData.length >= 2) {
        this.benefData.splice(index, 1);
        this.mayorEdad();
      }

    },
    async mayorEdad() {
      if (this.benefData.length != 0) {
        this.userData.typePlan = 'Familiar';

        const validBeneficiaries = this.benefData.filter(benef => benef.edad !== null);

        if (validBeneficiaries.length === 0) {
          this.userData.oldAux = this.userData.old.name;
        } else {
          const oldestBeneficiary = validBeneficiaries.reduce((oldest, current) => {
            return (current.edad.name > oldest.edad.name) ? current : oldest;
          }, validBeneficiaries[0]);

          if (this.benefData.length == 1) {
            this.userData.oldAux = oldestBeneficiary.edad.name;
          } else {
            this.userData.oldAux = this.userData.old.name < oldestBeneficiary.edad.name ? oldestBeneficiary.edad.name : this.userData.old.name;
          }

        }

      } else {
        this.userData.oldAux = this.userData.old.name;
        this.userData.typePlan = 'Individual';
      }

    },
    async getAgeList() {
      this.loadingAgeList = true;
      this.agelist = await agelist.getAgeList();
      this.loadingAgeList = false;
    },
    async getHijoList() {
      this.loadingHijoList = true;
      this.hijoList = await hijoList.getHijoList();
      this.loadingHijoList = false;
    },
    async getPartnerList() {
      this.loadingPartnerAgeList = true;
      this.partnerList = await partnerList.getAgeList();
      this.loadingPartnerAgeList = false;
    },
    capitalizeName(name) {
      if (!name) return '';
      return name.charAt(0).toUpperCase() + name.slice(1);
    },
    async next() {

      if (this.planDataAux.plan.cantBenf.includes('familiar')) {

        if (this.$refs.form.validate()) {

          this.logicMethod();

        } else {
          swal({
            title: "¡Atención!",
            text: "¡Complete los datos de los beneficiarios!",
            icon: "info",
            button: "Completar",
          });
        }
      } else {
        this.logicMethod();
      }
    },
    async logicMethod() {

      // reCaptcha v3 token
      await this.$recaptchaLoaded();
      const tokenStep = await this.$recaptcha('captchaToken');

      const planDataLocal = JSON.stringify(this.planDataAux);
      const encryptedPlanDataLocal = CryptoJS.AES.encrypt(planDataLocal, this.secretKey).toString();
      sessionStorage.setItem('planData', encryptedPlanDataLocal);

      const benefDataLocal = JSON.stringify(this.benefData);
      const encryptedbenefDataLocal = CryptoJS.AES.encrypt(benefDataLocal, this.secretKey).toString();
      sessionStorage.setItem('benefData', encryptedbenefDataLocal);

      this.userData.typePlan = this.planDataAux.plan.cantBenf.includes('familiar') ? 'Familiar' : 'Individual';

      const userDataLocal = JSON.stringify(this.userData);
      const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
      sessionStorage.setItem('userData', encryptedUserDataLocal);

      try {

        let carro = await ShieldService.newCreateStep(this.userData, this.planDataAux.plan.cantBenf.includes('familiar') ? this.benefData : {}, this.planDataAux, this.servicesData, 'Planes', tokenStep);
        this.servicesData.type = 'update';
        this.servicesData.stepId = carro.data.data._id;

      } catch (error) {
        console.log("Cart Fail");
      }

      if (this.userData.email && this.activeCampaingUse == 'TRUE') {
        const activeCampaingRes = await ShieldService.getContactActiveCampain(this.userData.email);

        this.servicesData.contactID = activeCampaingRes.data.data.contacts[0].id;

        await ShieldService.updateContactActiveCampain(null, this.planDataAux, this.servicesData, 1);

      }

      const servicesDataLocal = JSON.stringify(this.servicesData);
      const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
      sessionStorage.setItem('servicesData', encryptedServicesDataLocal);

      // if (this.planDataAux.plan.cantBenf.includes('familiar')) {
      //   this.$router.push({ path: '/og/beneficiarios' })
      // } else {
      //   this.$router.push({ path: '/og/dps' })
      // }

      this.$router.push({ path: '/og/dps' })
    },
  },
};
</script>

<style scoped>
/* img {
    border-style: none;
    width: 100%;
} */
.listBenef {
  margin-left: -5%;
}

.v-expansion-panel:not(:first-child)::after {
  border-top: none !important;
}

.titleLabel2 {
  display: flex;
  justify-content: center;
  text-align: center;
  margin-bottom: 3%;
  font-weight: 600;
  font-size: 16px;
  color: #2D387C !important;
  margin-top: -1% !important;
}

.ContainerPlans {
  border: 2px solid #D4D4D4;
  border-radius: 12px;
}

.hrLinePlan {
  border: 1px solid #D4D4D4;
  border-radius: 12px;
}

.line-break {
  display: block;
}

.labelElige {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: #232323;
  opacity: 0.75;
  padding: 2%;
}

.labelPlanes {
  font-family: Poppins;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;
  letter-spacing: -0.01em;
  color: #2D387C;
}

.planSubTopes {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.02em;
  text-align: left;
  color: #4F74E3;
}

.planSubShield {
  background: #F3F3F3;
  border-radius: 4px;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: auto;
  margin-top: 8px;
  width: 90%;
}

.planSubShieldDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  text-align: justify;
  color: #2D387C;
  margin: auto;
  width: 83%;
}

.planInidivual {
  width: 100%;
  background: linear-gradient(219deg, #F5F6FF 0%, #DADCFB 50%), #D8D8D8;
  border-radius: 10px 10px 0px 0px;
  transform: matrix(1, 0, 0, 1, 0, 0);
  margin: auto;
  min-width: 300px;
}

.planInidivualDetalle {
  background: linear-gradient(192.38deg, #C4C6FF 3.57%, #F5F6FF 107.06%), #D8D8D8;
  transform: matrix(1, 0, 0, 1, 0, 0);
  width: 327px;
}

.planInidivualName {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #343497;
}

.planIndividualPrecio {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 36px;
  text-align: center;
  letter-spacing: -0.01em;
  color: #343497;
}

.planIndividualSubPrecio {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  color: #000000;
}

.planIndividualDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  color: #000000;
}

.planIndividualSubDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: #343497;
}

.planIndividualVerMas {
  background: #617BFB;
  border-radius: 0px 0px 10px 10px;
  width: 100%;
  height: 38.91px;
  text-transform: uppercase;
}

.planIndividualProtegete {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: normal;
  text-align: center;
  letter-spacing: 0.02em;
  color: #343497;
  /* background-color: black !important; */
}

.planIndividualCaracteristicas {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 128.02%;
  text-align: center;
  letter-spacing: 0.02em;
  color: #3C3C3C;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.planIndividualBeneficios {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: #3C3C3C;
  flex: none;
  order: 1;
  flex-grow: 0;
  width: 75%;
  /* text-indent: -15px; */
  text-align: justify;
  margin: auto;
}

.planIndividualBeneficios::before {
  content: '';
  background-image: url('../assets/images/ticket-blue.png');
  /* Ruta a tu imagen de ícono */
  background-size: cover;
  /* Ajustar la imagen para que cubra completamente el área */
  background-repeat: no-repeat;
  /* Evitar que la imagen se repita */
  position: absolute;
  width: 16px !important;
  /* Ancho del ícono */
  height: 16px !important;
  /* Altura del ícono */
  margin-left: -26px;
  margin-top: 9px;
}

.planIndividualVerDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  align-items: center;
  text-align: center;
  letter-spacing: 1px;
  text-decoration-line: none;
  color: #4040A3;
  text-shadow: 4px 8px 24px rgba(251, 148, 0, 0.25);
}

.elegirPlan {
  box-sizing: border-box;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  gap: 10px;
  height: 39px;
  top: calc(50% - 39px/2 + 100px);
  background: #4F74E3;
  border: 2px solid #4F74E3;
  border-radius: 8px;
}

.elegirPlan2 {
  box-sizing: border-box;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  gap: 10px;
  height: 39px;
  top: calc(50% - 39px/2 + 100px);
  background: #4F74E3;
  border: 2px solid #4F74E3;
  border-radius: 8px;
}

.skin-movil {
  background: #FFFFFF;
  background-position: center;
  background-size: cover;
  border-color: #ECECEC;
  border: 1px solid #ECECEC;
}

.planFamiliar {
  width: 100%;
  background: linear-gradient(294.61deg, #2D387C -41.93%, #4F74E3 40.77%);
  border-radius: 10px 10px 0px 0px;
  transform: matrix(1, 0, 0, 1, 0, 0);
  margin: auto;
}

.planFamiliarRecomendado {
  display: flex;
  /* flex-direction: row;
  justify-content: center; */
  align-items: center;
  /* padding: 5px 25px;
  gap: 8px; */
  width: 136px;
  height: 22px;
  border-radius: 10px 10px 0px 0px;
}

.planFamiliarConveniente {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 12px;
  /* letter-spacing: 0.5px; */
  text-transform: uppercase;
  color: #FFFFFF;
  flex: none;
  order: 0;
  background: linear-gradient(294.61deg, #2D387C -41.93%, #4F74E3 40.77%);
  padding: 8px 25px;
  gap: 8px;
  width: 100%;
  height: 52px;
  border-radius: 12px 12px 0px 0px;
  /* margin-left: 45%; */
  min-width: 300px;
  text-align: center;
  margin: auto;
  place-content: center;
}

.planFamiliarConvenienteValid {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #FFFFFF;
  flex: none;
  order: 0;
  background: linear-gradient(270deg, #4F74E3 -15.95%, #2D387C 40.73%, #4F74E3 115.59%);
  padding: 8px 25px;
  gap: 8px;
  width: 100%;
  height: 28px;
  border-radius: 0px 0px 0px 0px;
  /* margin-left: 45%; */
  min-width: 300px;
  text-align: center;
}

.planShield {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 66px;
  background: #ECF0FC;
  border-radius: 4px;
  width: 90%;
  margin: auto;
}

.imgShield {
  width: 35px;
  height: 35px;
  margin-left: 7px;
}

.imgSand {
  width: 25px;
  height: 25px;
  /* margin: auto; */
}

.planShieldDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  text-align: justify;
  color: #2D387C;
  margin: auto;
  width: 78% !important;
}

.planFamiliarName {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 29px;
  text-align: center;
  color: #2D387C;
  margin: auto;
  margin-top: 0%;
}

.planFamiliarPrecio {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 39px;
  line-height: 34px;
  text-align: center;
  letter-spacing: -0.01em;
  color: #4F74E3;
}

.planFamiliarSubPrecio {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
  text-align: center;
  color: #2D387C;
  margin-bottom: 0px !important;
}


.planFamiliarDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 14px;
  text-align: center;
  color: #FFFFFF;
}

.planFamiliarSubDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: #2D387C;
  margin: auto;
  justify-content: center;
  justify-items: center;
  align-items: center;
  display: flex;
  margin-top: 3%;
}

.v-expansion-panel-header {
  background: #ECF0FC !important;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 28px;
  color: #2D387C;
  border-radius: 10px !important;
  padding: 3px 20px;
  /* // height: 75% !important; */
}

.v-expansion-panels {
  margin: auto;
  width: 93% !important;
}

.v-expansion-panel {
  flex: 9 0 99%;
  max-width: 100%;
  position: initial !important;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.text-expan {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 13px !important;
  line-height: 25px;
  color: #4D4D4D !important;
  margin-top: 3% !important;
  width: 100%;
}

.planFamiliarVerMas {
  background: #343497;
  border-radius: 0px 0px 10px 10px;
  width: 100%;
  height: 38.91px;
  text-transform: uppercase;
  margin: auto;
}

.planFamiliarProtegete {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  text-align: center;
  letter-spacing: 0.02em;
  color: #FFFFFF;
}

.planFamiliarCaracteristicas {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 128.02%;
  text-align: center;
  letter-spacing: 0.02em;
  color: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
}

.planFamiliarBeneficios {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: #3C3C3C;
  flex: none;
  order: 1;
  flex-grow: 0;
  width: 191px;
  /* text-indent: -15px; */
  text-align: justify;
  margin: auto;
}

.planFamiliarBeneficios::before {
  content: '';
  background-image: url('../assets/images/ticket-blue.png');
  /* Ruta a tu imagen de ícono */
  background-size: cover;
  /* Ajustar la imagen para que cubra completamente el área */
  background-repeat: no-repeat;
  /* Evitar que la imagen se repita */
  position: absolute;
  width: 16px !important;
  /* Ancho del ícono */
  height: 16px !important;
  /* Altura del ícono */
  margin-left: -23px;
}

.planFamiliarVerDetalle {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  align-items: center;
  text-align: center;
  letter-spacing: 1px;
  text-decoration-line: underline;
  text-transform: uppercase;
  color: #4040A3;
  text-shadow: 4px 8px 24px rgba(251, 148, 0, 0.25);
}

.texto {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: rgba(0, 0, 0, 0.5);
  flex: none;
  order: 1;
  flex-grow: 0;
}

.textoAzul {
  font-family: Poppins;
  font-style: normal;
  font-weight: 400px;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: #2D387C;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.encabezado {
  color: #2D387C;
  font-size: 18px;
  font-weight: 600;
}

.superpuesto {
  content: 'Nuevo';
  margin-top: -11% !important;
  width: 45px !important;
  height: 32px;
  justify-content: center;
  align-items: center;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: bold;
  background: #4F74E3;
  border-radius: 0px 10px 0px 20px;
  margin-left: 255px;
  margin-bottom: -2px;
}

.p-desc {
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 11px;
  align-items: center;
  text-align: center;
  letter-spacing: -0.02em;
  color: #FFFFFF;
  margin: auto;
}

.superpuestoFam {
  content: 'Nuevo';
  margin-top: -3% !important;
  width: 45px !important;
  height: 32px;
  justify-content: center;
  align-items: center;
  color: #2D387C;
  font-size: 14px;
  font-weight: bold;
  background: #ECECEC;
  border-radius: 0px 0px 0px 20px;
  margin-left: 255px;
  margin-bottom: -2px;
}

.p-descFam {
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  line-height: 11px;
  align-items: center;
  text-align: center;
  letter-spacing: -0.02em;
  color: #2D387C;
  margin: auto;
}

.benef-remove {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  background: transparent;
  border: 0;
  color: #C0392B;
  font-size: 12px;
  cursor: pointer;
  padding: 0;
}

.benef-title {
  color: #1f2a8a;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: .5px;
}

#app>div>main>div>div>div.v-stepper.v-sheet.theme--light.elevation-0>div.v-stepper__items>div>div>div:nth-child(11)>div:nth-child(2)>div {
  border-radius: 10px 10px 10px 10px;
}

.v-expansion-panel::before {
  content: none;
}
</style>